import axios from "axios";

export default async function decode(data: any) {
    try {
        const res = await axios.post("/api/decode", data);
        return res.data?.status === 200 ? res.data?.data : null;
    } catch (error) {
        console.log("🚀 ~ decode ~ error:", error);
        return null;
    }
}
